var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseSideBarLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9995 12L9.99951 8L13.9995 4",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99951 -1.3H15.9995C18.9266 -1.3 21.2995 1.07289 21.2995 4H18.6995C18.6995 2.50883 17.4907 1.3 15.9995 1.3H3.99951V-1.3ZM21.2995 12C21.2995 14.9271 18.9266 17.3 15.9995 17.3H3.99951V14.7H15.9995C17.4907 14.7 18.6995 13.4912 18.6995 12H21.2995ZM3.99951 16V0V16ZM15.9995 -1.3C18.9266 -1.3 21.2995 1.07289 21.2995 4V12C21.2995 14.9271 18.9266 17.3 15.9995 17.3V14.7C17.4907 14.7 18.6995 13.4912 18.6995 12V4C18.6995 2.50883 17.4907 1.3 15.9995 1.3V-1.3Z",
    fill: "white",
    mask: "url(#path-1-inside-1_26_130)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.65 4.00001C0.65 2.14985 2.14985 0.65 4 0.65H4.15V15.35H4C2.14985 15.35 0.65 13.8502 0.65 12V4.00001Z",
    stroke: "white",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseSideBarLeft);
export default __webpack_public_path__ + "static/media/collapse_side_bar_left.2453b59be7505cb3b1c890169d7fca89.svg";
export { ForwardRef as ReactComponent };